import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import {SmallUnderline} from "../../styles/components/SmallUnderline";
import {Button} from "../button/Button";
import { push } from "react-router-redux";
import { connect } from 'react-redux';
import { ComponentFrame } from "../../frame/ComponentFrame";
import { SectionHeader } from "../section-header/SectionHeader";
import joinPath from 'path.join';

/**
 * Case story section component.
 * This component gets it's data from parent component.
 */
class CaseStorySectionContainer extends React.Component {

  render(){
    let header = null;

    if(!this.props.hideHeader) {
      header = (
        <SectionHeader align="center"
                       color="white"
                       title="Case Stories"/>
      );
    }

    const case_story_container_props = {
      className: ["case-stories-container", "background-gradient"],
      style: {}
    };

    if( this.props.heroImage ) {
      case_story_container_props.style = {
        backgroundImage: `url(${this.props.heroImage})`
      };
    }

    case_story_container_props.className = case_story_container_props.className.join(' ');

    return (
      <ComponentFrame tag="section"
                      width="full"
                      header={header}>
        <div { ...case_story_container_props }>
          <div className={ "blend-blue-gradient"}/>
          <Container>
            <Row>
              <Col xs="12">{ /* lg={this.props.thumbnail ? 8 : 12} */ }
                <SmallUnderline align="left">
                  <h2>{ this.props.title || "" }</h2>
                </SmallUnderline>
                <span>{ this.props.date }</span>
                <p className="case-subtitle"
                   dangerouslySetInnerHTML={{
                     __html: this.props.excerpt
                   }}/>
              </Col>
              {/*
                Boolean(this.props.thumbnail) &&
                <Col xs="12" lg="4" className={"case-story-right"}>
                  <div>
                    <img width={this.props.thumbnail.media_details.sizes.full.width}
                         height={this.props.thumbnail.media_details.sizes.full.height}
                         src={this.props.thumbnail.media_details.sizes.full.source_url}
                         alt={this.props.thumbnail.alt_text} />
                    {
                      Boolean(this.props.thumbnail.caption && this.props.thumbnail.caption.rendered) &&
                      <div dangerouslySetInnerHTML={{
                          __html: this.props.thumbnail.caption.rendered
                        }}/>
                    }
                  </div>
                </Col>
               */}
              <Col xs="12" className={"case-story-buttons"}>
                <Button onClick={ () => this.props.changeLocation(joinPath("/news/", this.props.slug )) }>Read More</Button>
              </Col>
            </Row>
          </Container>
        </div>
      </ComponentFrame>

    );
  }
}

export const CaseStorySection = connect(
  null,
  dispatch => ({
      changeLocation: location => dispatch(push(location)),
  })
)(CaseStorySectionContainer);



// WEBPACK FOOTER //
// ./src/components/case-stories/CaseStorySection.js